<section #containerContact id="containerContact" class="section contact active">
  <!-- <h2 data-translate="CONTACT.TITLE" class="title"></h2> -->
  <div #contactWrapper class="contact-wrapper">
    <form [formGroup]="contactForm" (ngSubmit)="sendMessage()" class="contact-form">
      <h3 data-translate="CONTACT.HEADER"></h3>

      <div class="field-box">
        <!-- NAME -->
        <div class="field-group">
          <input type="text" formControlName="name" data-translate-placeholder="CONTACT.FIELDS.NAME.PLACEHOLDER"
            placeholder="" required>
          <div class="error-msg" *ngIf="contactForm.get('name')!.invalid && contactForm.get('name')!.touched"
            data-translate="CONTACT.ERRORS.NAME_REQUIRED">
          </div>
        </div>

        <!-- EMAIL -->
        <div class="field-group">
          <input type="email" formControlName="email" data-translate-placeholder="CONTACT.FIELDS.EMAIL.PLACEHOLDER"
            placeholder="" required>
          <div *ngIf="contactForm.get('email')!.errors?.['required'] && contactForm.get('email')!.touched"
            data-translate="CONTACT.ERRORS.EMAIL_REQUIRED" class="error-msg">
          </div>
          <div *ngIf="contactForm.get('email')!.errors?.['email'] && contactForm.get('email')!.touched"
            data-translate="CONTACT.ERRORS.EMAIL_INVALID" class="error-msg">
          </div>
        </div>

        <!-- PHONE -->
        <div class="field-group">
          <input type="text" formControlName="phone" maxlength="25"
            data-translate-placeholder="CONTACT.FIELDS.PHONE.PLACEHOLDER" placeholder="">
        </div>

        <!-- SUBJECT -->
        <div class="field-group">
          <input type="text" formControlName="subject" data-translate-placeholder="CONTACT.FIELDS.SUBJECT.PLACEHOLDER"
            placeholder="" required>
          <div *ngIf="contactForm.get('subject')!.invalid && contactForm.get('subject')!.touched"
            data-translate="CONTACT.ERRORS.SUBJECT_REQUIRED" class="error-msg">
          </div>
        </div>

        <!-- MESSAGE -->
        <div class="field-group">
          <textarea formControlName="message" data-translate-placeholder="CONTACT.FIELDS.MESSAGE.PLACEHOLDER"
            placeholder="" required></textarea>
          <div *ngIf="contactForm.get('message')!.invalid && contactForm.get('message')!.touched"
            data-translate="CONTACT.ERRORS.MESSAGE_REQUIRED" class="error-msg">
          </div>
        </div>
      </div>

      <div class="contact-btn">
        <button type="submit" class="btn" data-translate="CONTACT.BUTTON"></button>
        <p class="error-msg" *ngIf="submissionError">
          Es gab ein Problem beim Versenden. Bitte versuchen Sie es später erneut.
        </p>
      </div>

    </form>
  </div>
  <app-footer (toggleImprint)="toggleImprint.emit()" (togglePrivacy)="togglePrivacy.emit()">
  </app-footer>
</section>
